export const formatPlanFee = (frequency, fee) => {
    let amount = Number((fee / 100).toFixed(2));
    amount = '$' + amount;
    return amount + " " + frequency;
}